import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Lightweight show/hide wrapper for the Reports page. Renders a tappable
 * header bar; the heavy child (report card / table) only mounts when expanded,
 * so the page loads clean with just the essentials and everything else is
 * one tap away. Collapsed by default unless defaultOpen is set.
 */
export const CollapsibleSection = ({ title, subtitle, defaultOpen = false, testid, children }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div data-testid={testid ? `${testid}-section` : undefined}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                aria-expanded={open}
                data-testid={testid ? `${testid}-toggle` : undefined}
                className="w-full flex items-center justify-between gap-3 rounded-2xl border border-white/10 bg-[#0e0e0e] px-5 py-4 text-left hover:bg-white/[0.06] active:scale-[0.997] transition-colors"
            >
                <div className="min-w-0">
                    <p className="text-sm font-black tracking-wide text-white truncate">{title}</p>
                    {subtitle && <p className="text-[11px] text-[#A0AAB2] truncate mt-0.5">{subtitle}</p>}
                </div>
                <span className="flex items-center gap-2 shrink-0 text-[#FFD700]">
                    <span className="text-[10px] font-bold uppercase tracking-wider hidden sm:inline">{open ? 'Hide' : 'Show'}</span>
                    <ChevronDown className={`w-5 h-5 transition-transform ${open ? 'rotate-180' : ''}`} />
                </span>
            </button>
            {open && <div className="mt-3">{children}</div>}
        </div>
    );
};

export default CollapsibleSection;
